module.exports = __webpack_public_path__ + "static/media/7C.45deedc6.png";